import * as React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
  size?: number;
};

const SvgGoldBars = ({ size = 18, width, height, ...props }: Props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 18 18'
    width={width ?? size}
    height={height ?? size}
    fill='none'
    {...props}
  >
    <g stroke='currentColor' strokeLinejoin='round' clipPath='url(#GoldBars_svg__a)'>
      <path d='M8.34 15.682H2.13a.623.623 0 0 1-.615-.75l.57-2.82a.63.63 0 0 1 .615-.502h5.07a.63.63 0 0 1 .615.502l.57 2.82a.622.622 0 0 1-.615.75ZM15.87 15.682H9.66a.624.624 0 0 1-.615-.75l.57-2.82a.63.63 0 0 1 .615-.502h5.07a.63.63 0 0 1 .615.502l.57 2.82a.622.622 0 0 1-.615.75Z' />
      <path d='M12.105 11.617h-6.21a.62.62 0 0 1-.615-.75l.57-2.82a.63.63 0 0 1 .615-.502h5.07a.63.63 0 0 1 .615.502l.57 2.82a.62.62 0 0 1-.615.75Z' />
      <path strokeLinecap='round' d='M9 4.41V2.28M11.355 5.28l1.822-1.05M4.822 4.252l1.815 1.05' />
    </g>
    <defs>
      <clipPath id='GoldBars_svg__a'>
        <path fill='#fff' d='M0 0h18v18H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgGoldBars;
